'use client';

export default function MaintenancePage() {
    return (
        <>
            <style>{`
                .maintenance-wrapper {
                    width: 100vw;
                    height: 100vh;
                    background: linear-gradient(to bottom, #0377ce, #2da1f6);
                    overflow: hidden;
                }
                .maintenance-img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                    object-position: center;
                    background-color: transparent;
                    transform: scale(1.9);
                }
            `}</style>
            <div className="maintenance-wrapper">
                <img
                    src="/images/MaintenancePageBackground.webp"
                    alt="We'll be back shortly — Indy.auction is currently down for a scheduled maintenance."
                    className="maintenance-img"
                    fetchpriority="high"
                    width="1920"
                    height="1080"
                />
            </div>
        </>
    );
}
